import { type LedgerAccount } from '../components/admin/types'

export interface BalanceFilterOptions {
  minBalance?: string
  maxBalance?: string
  hideZero?: boolean
}

/**
 * Filters ledger accounts based on balance criteria
 * @param accounts - Array of ledger accounts to filter
 * @param options - Filter options including minBalance, maxBalance, and hideZero
 * @returns Filtered array of ledger accounts
 */
export function filterAccountsByBalance (
  accounts: LedgerAccount[],
  options: BalanceFilterOptions
): LedgerAccount[] {
  return accounts.filter(account => {
    const balance = parseFloat(String(account.entry_sum))

    // Hide zero balance accounts if requested
    if (options.hideZero && balance === 0) {
      return false
    }

    // Filter by minimum balance
    if (options.minBalance !== undefined && options.minBalance !== '') {
      const minVal = parseFloat(options.minBalance)
      if (!isNaN(minVal) && balance < minVal) {
        return false
      }
    }

    // Filter by maximum balance
    if (options.maxBalance !== undefined && options.maxBalance !== '') {
      const maxVal = parseFloat(options.maxBalance)
      if (!isNaN(maxVal) && balance > maxVal) {
        return false
      }
    }

    return true
  })
}
